<template>
	<el-dialog
		custom-class="dialog-content"
		:append-to-body="true"
		title="招商撞单提醒"
		:visible.sync="dialogVisible"
		width="800px"
		:before-close="handleClose"
	>
		<div class="fz-14 yx-color-text-primary mb-10">以下商品对应店铺的对接人非新分配的招商运营，请确认是否修改店铺对接人?</div>
		<el-radio v-model="radioValue" :label="1">是，更新为新招商运营</el-radio>
		<br />
		<el-radio class="mt-12" v-model="radioValue" :label="2">否，不更改，仅所选商品分配给新招商</el-radio>

		<base-table :key="total === 1" class="mt-24" :list="tableData" :columns="columns" :stickyHeader="false"> </base-table>
		<yx-pagination
			class="mb-24"
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			layout="total, prev, pager, next"
			@current-change="currentChange"
		/>
		<!-- 底部按钮部分 -->
		<div class="bottom">
			<div class="flex flex-just-end">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit()">确认</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import getColums from './columns';
import { commonList } from '@/api/cooperationProgress';
import { zsRoleType } from '@/utils/dataMap';
export default {
	data() {
		return {
			dialogVisible: false,
			radioValue: 2,
			tableData: [],
			pageInfo: {
				page_index: 1,
				page_size: 5,
			},
			total: 0,
			totalData: [],
			selectName: '',
			defaultList: [], // 添加的商品数组 到时候要用这个数组 传给后端
		};
	},
	methods: {
		async show(list, userId) {
			this.dialogVisible = true;
			this.defaultList = JSON.parse(JSON.stringify(list));
			this.selectName = await this.findMerchant(userId);
			// 过滤招商运营名字相当的数据 展示在撞单的列表里面 不做后续给后端的 传的数组
			let newList = list.filter(val => val.shop_claim_user_id != userId);
			this.totalData = newList.map(item => ({
				...item,
				newShopClaimUserName: this.selectName,
				shopClaimUserId: userId,
				operations: this.getButtons(item),
			}));
			this.total = this.totalData.length;
			this.sliceTotalData();
		},
		handleClose() {
			this.dialogVisible = false;
			this.radioValue = 2;
		},
		delGoods(row) {
			this.totalData = this.totalData.filter(val => val.product_id != row.product_id);
			this.defaultList = this.defaultList.filter(val => val.product_id != row.product_id);
			this.total = this.totalData.length;
			this.pageInfo.page_index = 1;
			this.sliceTotalData();
		},
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.sliceTotalData();
		},
		// 判断是否是一条数据 是的话 不让删除
		formatOnly() {
			this.totalData.map(val => {
				val.operations.map(v => {
					v.disabled = true;
					v.notSelf = true;
					
				});
			});
		},
		getButtons(row) {
			let arr = [];
			arr.push({
				label: '移除',
				type: 'text',
				classtype: 2,
				click: () => {
					this.delGoods(row);
				},
			});
			return arr;
		},
		/**
		 * 本地处理数据分页
		 */
		sliceTotalData() {
			const { page_index, page_size } = this.pageInfo;
			const startIndex = page_index === 1 ? 0 : (page_index - 1) * page_size;
			this.tableData = this.totalData.slice(startIndex, page_size * page_index);
			this.total === 1 && this.formatOnly();
		},
		submit() {
			const { radioValue, defaultList } = this;
			this.$emit('submit', { radioValue, product_ids: defaultList.map(item => item.product_id).join(',') });
		},
		/**
		 * 查找选择的招商名字
		 */
		async findMerchant(userId) {
			const { code, data } = await commonList({
				role_id: zsRoleType.id,
				all_status: 0,
				product_store_search: 0,
			});
			if (code !== 0) return;
			return data.filter(val => val.userId === userId)[0]?.name || '';
		},
	},
	computed: {
		columns() {
			return getColums(this);
		},
	},
	created() {},
};
</script>
<style lang="less" scoped>
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
